import React, { ElementType, ReactNode } from 'react';
import { Typography } from '../..';

import { CheckFieldEmotion, Label, Input, Icon, Content, IconWrapper } from './styles';

interface Props {
  label: string;
  type: 'radio' | 'checkbox';
  name: string;
  value?: string;
  icon?: ReactNode;
  disabled?: boolean;
  readOnly?: boolean;
  checked?: boolean;
  asContainer?: ElementType;
  onChange?: any;
}

export class CheckField extends React.Component<Props> {
  public render() {
    const {
      value,
      label,
      disabled,
      name,
      type,
      readOnly,
      icon,
      onChange,
      checked,
      asContainer,
      ...other
    } = this.props;

    return (
      <CheckFieldEmotion>
        <Label data-checked={checked} key={value} as={asContainer} {...other}>
          <Input
            type={type}
            value={value}
            disabled={disabled}
            name={name}
            readOnly={readOnly}
            inputType={type}
            onChange={onChange}
            checked={checked}
          />
          <Content inputType={type}>
            {icon && (
              <IconWrapper>{typeof icon === 'string' ? <Icon src={icon} /> : icon}</IconWrapper>
            )}
            <Typography.Text>{label}</Typography.Text>
          </Content>
          {this.props.children}
        </Label>
      </CheckFieldEmotion>
    );
  }
}

export type CheckFieldProps = Props;
